import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
    float: "right",
    marginTop: "5px",
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  header: {
    fontSize: "18pt",
    fontWeight: "bold",
  },
  detail: {
    fontSize: "15px",
    margin: "20px 0",
  },
  tech: {
    fontSize: "15px",
    color: "#adadad",
    margin: "30px 0",
  },
  blog_container: {
    width: "80%",
    margin: "0 auto",
  },
  blog_title: {
    marginTop: "40px",
    fontSize: "30pt",
  },
  blog_info: {
    display: "flex",
    alignItems: "center",
    marginTop: "30px",
  },
  blog_avatar: {
    width: "50px",
    borderRadius: "80px",
  },
  blog_create_info: {
    marginLeft: "20px",
  },
  blog_introduction: {
    marginTop: "15px",
    fontSize: "15pt",
  },
  blog_creator: {
    fontSize: "15pt",
  },
  blog_sub_container: {
    marginTop: "20px",
    borderTop: "solid 1px #d0d0d0",
    padding: "15px",
  },
  blog_sub_content: {
    marginTop: "10px",
    fontSize: "13pt",
  },
}));

const Blog = ({ blogs }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [blog, selectBlog] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const openBlog = (index) => {
    console.log(index);
    selectBlog(blogs[index]);
    setOpen(true);
  };

  const _blogs = blogs.map(
    ({ image, date, topic, comment, title, name, url, avatar }, index) => (
      <div className="col-lg-4" key={title}>
        <div className="post">
          <div className="box-img">
            <span className="category">{topic}</span>
            <img src={image} alt="" />
          </div>

          <div className="content">
            <div className="entry-meta">
              <span className="entry-date">
                <i className="jam jam-calendar"></i>
                {date}
              </span>
              <span className="before-category">in</span>
              <span className="category">
                <a target="_blank" href={url}>
                  {" "}
                  <span className="cat-name">{topic}</span>{" "}
                </a>
              </span>
              <span className="entry-comments">
                <i className="jam jam-message-alt"></i>
                {comment}
              </span>
            </div>

            <h3
              className="entry-title"
              style={{ cursor: "pointer" }}
              onClick={() => {
                openBlog(index);
              }}
            >
              {title}
            </h3>

            <div className="author">
              <div className="part-img">
                <img src={avatar} alt="" />
              </div>
              <div className="title">
                <p>{name}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );

  const _blogContent = blog
    ? blog.contents.map(({ subtitle, content }) => (
        <div className={classes.blog_sub_container} key={subtitle}>
          <h4>{subtitle}</h4>
          <div
            className={classes.blog_sub_content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      ))
    : null;

  console.log(_blogContent);
  return (
    <section id="blog" className="blog section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title-2">
              <div className="line"></div>
              <div className="title">
                <p>See Latest News</p>
                <h3>Blog</h3>
              </div>
            </div>
          </div>
          {_blogs}
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen={true}
      >
        <DialogTitle id="alert-dialog-title">
          <IconButton
            aria-label="delete"
            className={classes.margin}
            onClick={handleClose}
          >
            <CloseIcon fontSize="large" style={{ color: "FF0000" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {blog && (
            <div className={classes.blog_container}>
              <img src={blog.image} />
              <h3 className={classes.blog_title}>{blog.title}</h3>
              <div className={classes.blog_info}>
                <img className={classes.blog_avatar} src={blog.avatar} />
                <div className={classes.blog_create_info}>
                  <p className={classes.blog_creator}>{blog.name}</p>
                  <p>{blog.date}</p>
                </div>
              </div>
              <div className={classes.blog_introduction}>
                {blog.introduction}
              </div>
              {_blogContent}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Blog;
